<div class="progress-bar-circle">
  <circle-progress [percent]="progressCompleted" [radius]="radius" titleFontSize="{{titleFont}}" unitsFontSize="{{titleFont}}"></circle-progress>
</div>